// @ts-nocheck
(function initializeNoDrillPreviewCart() {
  'use strict';

  // Theme assets share one CDN folder; the cart script's own URL gives its base (empty in tests and local previews).
  const ASSET_BASE = (() => {
    const src = String(globalThis.document?.currentScript?.src || '');
    const at = src.indexOf('/assets/');
    return at >= 0 ? src.slice(0, at + 8) : '';
  })();

  const STORAGE_KEYS = ['ndr-preview-order-v2', 'ndr-preview-order-v4'];

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(Number(cents || 0) / 100);
  }

  function loadOrder() {
    return STORAGE_KEYS.flatMap((storageKey) => {
      try {
        const parsed = JSON.parse(globalThis.sessionStorage?.getItem(storageKey) || '[]');
        return Array.isArray(parsed)
          ? parsed.map((item) => ({
              ...item,
              optionSummary: Array.isArray(item.optionSummary)
                ? globalThis.NoDrillConfiguratorCore?.sanitizeOptionSummary(item.optionSummary)
                : item.optionSummary,
              storageNamespace: item.storageNamespace || storageKey,
            }))
          : [];
      } catch (_error) {
        return [];
      }
    });
  }

  function loadOrderAccessoryQuantities() {
    return STORAGE_KEYS.reduce((latest, storageKey) => {
      try {
        const parsed = JSON.parse(globalThis.sessionStorage?.getItem(`${storageKey}:order-accessories`) || '{}');
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length
          ? parsed
          : latest;
      } catch (_error) {
        return latest;
      }
    }, {});
  }

  function saveOrder(order) {
    STORAGE_KEYS.forEach((storageKey) => {
      const scopedOrder = order.filter((item) => (
        item.storageNamespace === storageKey
        || (!item.storageNamespace && storageKey === 'ndr-preview-order-v4')
      ));
      globalThis.sessionStorage?.setItem(storageKey, JSON.stringify(scopedOrder));
    });
  }

  function textElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = text;
    return element;
  }

  function setup(section) {
    const core = globalThis.NoDrillConfiguratorCore;
    const rulesNode = section.querySelector('[data-cart-rules]');
    const roomsNode = section.querySelector('[data-cart-rooms]');
    const emptyNode = section.querySelector('[data-cart-empty]');
    if (!core || !rulesNode || !roomsNode || !emptyNode) return;

    let rules;
    try {
      rules = JSON.parse(rulesNode.textContent);
    } catch (error) {
      console.error('No Drill cart rules could not be parsed.', error);
      return;
    }

    let order = loadOrder();
    saveOrder(order);
    let orderAccessoryQuantities = core.normalizeOrderAccessoryQuantities(loadOrderAccessoryQuantities());

    function setTotal(name, value) {
      const node = section.querySelector(`[data-cart-total="${name}"]`);
      if (node) node.textContent = value;
    }

    function renderRooms() {
      roomsNode.replaceChildren();
      emptyNode.hidden = order.length > 0;
      const grouped = core.groupConfigurationsByRoom(order);

      Object.entries(grouped).forEach(([room, configurations]) => {
        const group = document.createElement('section');
        group.className = 'ndr-cart-room';
        group.append(textElement('h2', 'ndr-cart-room__title', room));

        configurations.forEach((configuration) => {
          const item = document.createElement('article');
          item.className = 'ndr-cart-item';
          item.dataset.configurationId = configuration.configurationId;
          const details = document.createElement('div');
          const pricePending = true; // NDR-D-038 includes stale saved previews.
          const safeOptionSummary = Array.isArray(configuration.optionSummary)
            ? core.sanitizeOptionSummary(configuration.optionSummary)
            : null;
          const optionLine = Array.isArray(safeOptionSummary)
            ? safeOptionSummary.map((option) => option.value).join(' · ')
            : [configuration.color, configuration.lightControl].filter(Boolean).join(' · ');
          details.append(
            textElement('p', 'ndr-cart-item__category', configuration.categoryLabel || 'Custom no-drill treatment'),
            textElement('h3', '', configuration.roomLabel || 'Window'),
            textElement(
              'p',
              '',
              [optionLine, configuration.controlLabel].filter(Boolean).join(' · '),
            ),
            textElement(
              'p',
              'ndr-cart-item__size',
              `${core.formatInches(configuration.productionWidth || configuration.width)} × ${core.formatInches(configuration.height)} · ${pricePending ? 'Pricing pending' : `Band ${configuration.priceBandId}`}`,
            ),
          );
          const price = textElement(
            'strong',
            'ndr-cart-item__price',
            pricePending ? 'Price pending' : formatMoney(configuration.totalCents, rules.currency),
          );
          const edit = textElement('button', 'ndr-cart-item__edit', 'Edit');
          edit.type = 'button';
          edit.addEventListener('click', () => {
            const edit_configuration = configuration.configurationId;
            const target = configuration.editUrl || (globalThis.location.pathname.endsWith('.html') ? 'configurator.html' : '/collections/all?view=no-drill-roller-configurator');
            const url = new URL(target, globalThis.location.href);
            url.searchParams.set('edit_configuration', edit_configuration);
            globalThis.location.href = `${url.pathname}${url.search}${url.hash}`;
          });
          const remove = textElement('button', 'ndr-cart-item__remove', 'Remove');
          remove.type = 'button';
          remove.addEventListener('click', () => {
            order = order.filter((item) => item.configurationId !== configuration.configurationId);
            saveOrder(order);
            render();
          });
          const controls = document.createElement('div');
          controls.className = 'ndr-cart-item__controls';
          controls.append(price, edit, remove);
          item.append(details, controls);
          group.append(item);
        });
        roomsNode.append(group);
      });
    }

    function renderSummary() {
      const summary = core.summarizeOrder(order, rules);
      const pricePending = true; // No retail totals are approved.
      const remoteRequirement = core.summarizeMotorizedRemoteRequirement(order, orderAccessoryQuantities);
      const remoteSummary = section.querySelector('[data-cart-remote-summary]');
      const remoteTotal = section.querySelector('[data-cart-remote-total]');
      const remoteAlert = section.querySelector('[data-cart-remote-alert]');
      if (remoteSummary) remoteSummary.hidden = remoteRequirement.motorizedShadeCount === 0;
      if (remoteTotal) {
        remoteTotal.textContent = `${remoteRequirement.oneChannelRemoteQuantity} one-channel · ${remoteRequirement.sixteenChannelRemoteQuantity} sixteen-channel`;
      }
      if (remoteAlert) {
        remoteAlert.hidden = remoteRequirement.valid;
        remoteAlert.textContent = remoteRequirement.valid ? '' : remoteRequirement.message;
      }
      setTotal('quantity', String(summary.quantity));
      const benefit = section.querySelector('[data-cart-benefit]');
      if (pricePending) {
        setTotal('subtotal', 'Price pending');
        setTotal('discount', 'Price pending');
        setTotal('total', 'Price pending');
        if (benefit) benefit.textContent = 'Draft to check only. Prices are not set. You cannot check out yet.';
        return;
      }
      setTotal('subtotal', formatMoney(summary.subtotalCents, rules.currency));
      setTotal(
        'discount',
        summary.discountPercent
          ? `−${formatMoney(summary.discountCents, rules.currency)} (${summary.discountPercent}%)`
          : formatMoney(0, rules.currency),
      );
      setTotal('total', formatMoney(summary.totalCents, rules.currency));

      if (benefit) {
        benefit.textContent = summary.discountPercent
          ? `Your draft uses the ${summary.discountPercent}% price tier for ${summary.quantity} shades you set up.`
          : 'Add one more shade you set up. Then check the price tier for 2+ shades.';
      }
    }

    function render() {
      renderRooms();
      renderSummary();
    }

    const checkoutGate = section.querySelector('[data-checkout-gate]');
    checkoutGate?.addEventListener('click', () => {
      const benefit = section.querySelector('[data-cart-benefit]');
      if (benefit) benefit.textContent = 'You cannot check out in this shade preview.';
    });

    render();
  }

  // Hosted store: the cart is Shopify's own cart (NDR-D-060). Local .html previews keep the draft cart above.
  function cartRoot() {
    const value = globalThis.Shopify?.routes?.root || '/';
    return value.endsWith('/') ? value : `${value}/`;
  }

  async function cartRequest(path, options = {}) {
    const response = await globalThis.fetch(`${cartRoot()}${path}`, {
      credentials: 'same-origin',
      ...options,
      headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
    });
    let body = null;
    try {
      body = await response.json();
    } catch (_error) {
      body = null;
    }
    if (!response.ok) throw new Error(body?.description || body?.message || `We could not update your cart.`);
    if (!body || !Array.isArray(body.items)) throw new Error('We could not confirm your cart details.');
    return body;
  }

  const lineRole = (item) => item.properties?._ndr_line_role || 'shade';
  // Cart icon number: shades plus remotes and other stand-alone add-ons; side channels ride with their shade.
  const badgeCount = (cart) => (cart?.items || []).reduce((sum, item) => sum + (lineRole(item) === 'side_channel' ? 0 : Number(item.quantity) || 0), 0);

  // Black Friday sale (NDR-D-145): code BF51 takes 51% off every shade (all 96 shade price listings, including the
  // $399-and-up mirrors the cart map uses) until the close of Nov 30 Eastern. Albert (Nov 3) wants a real code step, so
  // the cart page adds the code for the shopper and shows it; ads can also use the link /discount/BF51.
  const SALE_ENDS_AT = Date.parse('2026-12-01T05:00:00Z');
  const SALE_CODE = 'BF51';

  async function removeLine(key, items = []) {
    const shade = items.find((item) => item.key === key && lineRole(item) === 'shade');
    const configurationId = shade?.properties?._configuration_id;
    const keys = [key, ...items.filter((item) => configurationId
      && lineRole(item) === 'side_channel' && item.properties?._configuration_id === configurationId).map((item) => item.key)];
    const updates = Object.fromEntries(keys.map((lineKey) => [lineKey, 0]));
    const cart = await cartRequest('cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });
    if (cart.items.some((item) => keys.includes(item.key))) throw new Error('An item requested for removal is still in the cart.');
    return cart;
  }

  // New shade lines keep the full record under hidden "_" names and show short lines at checkout (Oct 13).
  // Read the record first, then the plain name, so older carts keep working.
  function prop(properties, key) {
    const p = properties || {};
    return p[`_${key}`] ?? p[key];
  }

  function publicProperties(properties) {
    return Object.entries(properties || {}).filter(([key, value]) => (
      !String(key).startsWith('_') && value != null && String(value).trim() !== ''
    ));
  }

  function shadeSummary(properties = {}) {
    const text = (value) => String(value ?? '').trim();
    const width = text(prop(properties, 'Entered Width') || prop(properties, 'Width'));
    const height = text(prop(properties, 'Height'));
    const size = width && height ? `${width.replace(/\s*in$/, '')} × ${height}` : '';
    const fabric = [text(prop(properties, 'Fabric collection')), text(prop(properties, 'Color'))].filter(Boolean).join(', ');
    const mount = text(prop(properties, 'Mount') || prop(properties, 'Installation Method'));
    const side = text(prop(properties, 'Control side'));
    const control = text(prop(properties, 'Control')) ? `${text(prop(properties, 'Control'))}${side ? `, ${side.toLowerCase()} side` : ''}` : '';
    return [size, fabric, mount, control].filter(Boolean).join(' · ');
  }

  // Display-only filtering: Shopify line properties (the order record) are never changed.
  function displayRows(item) {
    const role = lineRole(item);
    const rows = publicProperties(item.properties).filter(([key]) => key !== 'Room' && key !== 'Room / Window Label');
    if (role === 'remote') {
      // The card title already names the remote; show which window it came with, once.
      return rows
        .filter(([key]) => key !== 'Remote')
        .filter(([key, value]) => !(key === 'Added with' && String(value).trim() === 'Order'))
        .map(([key, value]) => (key === 'Added with' ? ['For', value] : [key, value]));
    }
    if (role === 'shade') {
      // A paid remote appears once, under Remotes. Keep the row only when the shopper uses a remote they own.
      // The order record keeps "Control side" for the factory; the shopper sees the builder's name for it.
      return rows.filter(([key, value]) => !String(key).startsWith('Order Remote')
        && key !== 'Compatible Remote Confirmed'
        && !(key === 'Remote' && String(value).trim() !== 'Using another remote'))
        .map(([key, value]) => (key === 'Control side' ? ['Charging port side', value] : [key, value]));
    }
    return rows;
  }

  function remoteTitle(item) {
    return String(item.properties?.Remote || item.product_title || 'Remote').replace(/\s*\(x\d+\)\s*$/, '');
  }

  function swatchUrl(properties = {}, base = ASSET_BASE) {
    const code = String(properties?._material_code || '').trim();
    if (!base || !/^NDR-V2-[A-Z]{2}-[A-Z]{2}-\d{3}-C\d{2}$/.test(code)) return '';
    return `${base}${code.toLowerCase()}.png?width=240`;
  }

  function groupCartItems(items) {
    const groups = new Map();
    const shades = new Map();
    const remotes = items.filter((item) => lineRole(item) === 'remote');
    items.filter((item) => lineRole(item) === 'shade').forEach((item) => {
      const id = item.properties?._configuration_id;
      if (id && !shades.has(id)) shades.set(id, { ...item, sideChannels: [] });
    });
    items.filter((item) => lineRole(item) === 'side_channel').forEach((item) => {
      shades.get(item.properties?._configuration_id)?.sideChannels.push(item);
    });
    items.forEach((item) => {
      const role = lineRole(item);
      if (role === 'remote' || (role === 'side_channel' && shades.has(item.properties?._configuration_id))) return;
      let room = String(prop(item.properties, 'Room') || '').trim() || 'Other windows';
      if (remotes.length && room === 'Remotes') room = 'Remotes (room)';
      if (!groups.has(room)) groups.set(room, []);
      const shade = shades.get(item.properties?._configuration_id);
      groups.get(room).push(shade?.key === item.key ? shade : { ...item, sideChannels: [] });
    });
    if (remotes.length) groups.set('Remotes', remotes);
    return groups;
  }

  function remoteWarning(items) {
    const motorized = items.filter((item) => lineRole(item) === 'shade' && prop(item.properties, 'Control') === 'Motorized');
    return motorized.length && !items.some((item) => lineRole(item) === 'remote')
      && !motorized.some((item) => prop(item.properties, 'Remote') === 'Using another remote')
      ? 'Your motorized shades need a remote. Add one below, or note that you already own one.' : '';
  }

  // The remote form is only offered when the cart has a motorized shade (owner, Oct 6).
  const isMotorizedShade = (item) => lineRole(item) === 'shade' && prop(item.properties, 'Control') === 'Motorized';

  function remoteOrphanNote(items) {
    return items.some((item) => lineRole(item) === 'remote') && !items.some(isMotorizedShade)
      ? 'You have a remote but no motorized shades. Remove it if you don’t need it.' : '';
  }

  // Heads-up when motorized shades span more rooms than the cart has remotes (owner, Oct 6).
  // "Using another remote" can mean a remote bought for another room, so it does not cover a room.
  function remoteRoomNote(items) {
    const remotes = items.filter((item) => lineRole(item) === 'remote')
      .reduce((sum, item) => sum + Math.max(0, Number(item.quantity) || 0), 0);
    const need = new Set(items.filter(isMotorizedShade).map((item) => String(prop(item.properties, 'Room') || '').trim())).size;
    return remotes >= 1 && remotes < need
      ? `You have motorized shades in ${need} rooms but ${remotes} remote${remotes === 1 ? '' : 's'}. You may want a remote in each room. Add one below.`
      : '';
  }

  const REMOTE_LABELS = { one_channel: '1-channel', six_channel: '6-channel', sixteen_channel: '16-channel' };
  const ADDONS_UNAVAILABLE = 'You cannot add extras right now. Please try again later.';

  // Each cart-page add is its own line. Retries of one add keep its id; a new add gets a new id.
  const REMOTE_ADD_ID = /^[A-Za-z0-9-]{6,64}$/;
  function newRemoteAddId() {
    return globalThis.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function remoteRequest(client, type, quantity, addId = newRemoteAddId()) {
    if (!Object.hasOwn(REMOTE_LABELS, type)) throw new Error('Choose a remote type.');
    if (!REMOTE_ADD_ID.test(String(addId))) throw new Error(ADDONS_UNAVAILABLE);
    const count = Number(quantity);
    if (!Number.isInteger(count) || count < 1 || count > 5) throw new Error('Choose a whole-number quantity from 1 to 5.');
    const resolved = client?.resolveRemote?.(type, count);
    if (!resolved?.valid) throw new Error(ADDONS_UNAVAILABLE);
    return {
      items: [{ id: resolved.id, quantity: count, properties: {
        _configuration_id: 'order', _ndr_line_role: 'remote', _ndr_cart_version: '2', _remote_add_id: String(addId),
        Remote: `${REMOTE_LABELS[type]} remote (x${count})`, 'Added with': 'Order',
      } }],
      expectedUnitCents: [resolved.unitCents],
    };
  }

  // Older clients may lack reconcile; never treat a partial or changed line as absent.
  function reconcileRemote(request, cart) {
    const expected = request.items[0];
    const addId = expected.properties._remote_add_id;
    const lines = cart.items.filter((item) => item.properties?._configuration_id === 'order'
      && (!addId || item.properties?._remote_add_id === addId));
    if (!lines.length) return false;
    const line = lines[0];
    const properties = line.properties || {};
    if (lines.length !== 1 || (line.variant_id ?? line.id) !== expected.id
      || line.quantity !== expected.quantity || line.original_price !== request.expectedUnitCents[0]
      || Object.keys(properties).length !== Object.keys(expected.properties).length
      || Object.entries(expected.properties).some(([key, value]) => properties[key] !== value)) {
      throw new Error('The remote in your cart changed. Check or remove it before you add one more.');
    }
    return true;
  }

  function cartEditUrl(item) {
    if (lineRole(item) !== 'shade') return '';
    try {
      const id = item.properties?._configuration_id;
      const records = JSON.parse(globalThis.localStorage.getItem('ndr-cart-edit-v1') || '{}');
      const record = id && Object.prototype.hasOwnProperty.call(records, id) ? records[id] : null;
      if (!record || record.v !== 1 || !record.configuration || typeof record.editUrl !== 'string'
        || !record.editUrl.startsWith('/') || record.editUrl.startsWith('//')) return '';
      const url = new URL(record.editUrl, globalThis.location.origin);
      if (url.origin !== globalThis.location.origin) return '';
      url.searchParams.set('edit_line', id);
      return url.href;
    } catch (error) { return ''; }
  }

  // Albert (Oct 20): Duplicate copies a shade with every choice. The copy gets its own id and a "(copy)" name,
  // and shows right under the original. Nothing else on the line changes, so the order sheet reads it the same way.
  const COPY_SUFFIX = / \(copy(?: (\d+))?\)$/;
  const LABEL_MAX = 80; // Same limit as the builder's window name box.
  const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);
  function windowFullName(room, label) {
    // Same rule as the builder: "Kitchen" + "Kitchen, Window 1" reads "Kitchen, Window 1".
    const r = String(room || '').trim(), l = String(label || '').trim();
    const lower = l.toLowerCase(), key = r.toLowerCase();
    if (!r || !l) return r || l;
    return lower === key || lower.startsWith(`${key},`) || lower.startsWith(`${key} `) ? l : `${r} - ${l}`;
  }
  const lineLabelText = (item) => String(prop(item?.properties, 'Room / Window Label') || '').trim();
  const copyNumber = (label) => { const match = COPY_SUFFIX.exec(label); return match ? Number(match[1] || 1) : 0; };
  function copyLabel(base, taken = new Set()) {
    const root = String(base || '').trim().replace(COPY_SUFFIX, '').trim() || 'Window';
    for (let n = 1; n < 100; n += 1) {
      const suffix = n === 1 ? ' (copy)' : ` (copy ${n})`;
      const label = `${root.slice(0, LABEL_MAX - suffix.length).trim()}${suffix}`;
      if (!taken.has(label.toLowerCase())) return label;
    }
    return '';
  }
  function canDuplicate(item, items = []) {
    if (lineRole(item) !== 'shade') return false;
    const p = item.properties || {};
    const id = p._configuration_id;
    if (typeof id !== 'string' || !id.trim() || id === 'order' || p._ndr_cart_version !== '2' || Number(item.quantity) !== 1) return false;
    // A remote bought with this shade belongs to it alone. A copy would have no remote, so we do not offer one.
    return !(prop(p, 'Control') === 'Motorized'
      && items.some((line) => lineRole(line) === 'remote' && line.properties?._configuration_id === id));
  }
  function duplicateRequest(id, items = [], newId) {
    const failed = { ok: false, message: 'We could not copy that shade.' };
    const shade = items.find((line) => lineRole(line) === 'shade' && line.properties?._configuration_id === id);
    if (!shade || !canDuplicate(shade, items) || typeof newId !== 'string' || !newId || newId === id) return failed;
    const channels = items.filter((line) => lineRole(line) === 'side_channel' && line.properties?._configuration_id === id);
    if (channels.length > 1 || channels.some((line) => Number(line.quantity) !== 1)) return failed;
    const p = shade.properties;
    const hidden = hasOwn(p, '_Room / Window Label');
    const labelKey = hidden ? '_Room / Window Label' : 'Room / Window Label';
    const room = String((hidden ? p._Room : p.Room) || '').trim();
    const taken = new Set(items.filter((line) => lineRole(line) === 'shade').map((line) => lineLabelText(line).toLowerCase()));
    const label = copyLabel(p[labelKey], taken);
    if (!label) return failed;
    const shadeProperties = { ...p, _configuration_id: newId, [labelKey]: label };
    if (hidden && hasOwn(p, 'Room')) shadeProperties.Room = windowFullName(room, label);
    const lines = [{ id: shade.variant_id, quantity: 1, properties: shadeProperties }];
    const cents = [shade.original_price];
    channels.forEach((line) => {
      const channel = { ...line.properties, _configuration_id: newId };
      if (hasOwn(channel, 'Room / Window Label')) channel['Room / Window Label'] = label;
      if (hasOwn(channel, 'For')) channel.For = `${windowFullName(channel.Room, label)} shade`;
      lines.push({ id: line.variant_id, quantity: 1, properties: channel });
      cents.push(line.original_price);
    });
    return { ok: true, items: lines, expectedUnitCents: cents, label, room, name: windowFullName(room, label) };
  }
  // Copies sit right under their original (and earlier copies) inside a room. Order is display only.
  function placeCopies(items = []) {
    const isShade = (item) => lineRole(item) === 'shade';
    const rootOf = (item) => lineLabelText(item).replace(COPY_SUFFIX, '').trim();
    const roots = new Set(items.filter((item) => isShade(item) && !copyNumber(lineLabelText(item))).map(lineLabelText));
    const moving = (item) => isShade(item) && copyNumber(lineLabelText(item)) > 0 && roots.has(rootOf(item));
    const out = items.filter((item) => !moving(item));
    items.filter(moving).sort((a, b) => copyNumber(lineLabelText(a)) - copyNumber(lineLabelText(b))).forEach((copy) => {
      let at = -1;
      out.forEach((item, index) => { if (isShade(item) && rootOf(item) === rootOf(copy)) at = index; });
      out.splice(at + 1, 0, copy);
    });
    return out;
  }
  const newCopyId = () => `ndr-${globalThis.crypto?.randomUUID?.()
    || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`}`;
  function copyEditRecord(oldId, newId, label) {
    // Device-only Edit shortcut. Never blocks a copy that is already in the cart.
    try {
      const stored = JSON.parse(globalThis.localStorage.getItem('ndr-cart-edit-v1') || '{}');
      if (!stored || typeof stored !== 'object' || Array.isArray(stored) || !hasOwn(stored, oldId)) return false;
      const record = stored[oldId];
      if (!record || record.v !== 1 || !record.configuration || typeof record.editUrl !== 'string') return false;
      stored[newId] = { ...record, savedAt: Date.now(), configuration: { ...record.configuration, roomLabel: label } };
      const newest = Object.entries(stored).sort((a, b) => (b[1]?.savedAt || 0) - (a[1]?.savedAt || 0)).slice(0, 50);
      globalThis.localStorage.setItem('ndr-cart-edit-v1', JSON.stringify(Object.fromEntries(newest)));
      return true;
    } catch (_error) { return false; }
  }

  async function localPicture(action, ...args) {
    try { return await globalThis.NoDrillPhotoStore?.[action]?.(...args) || {ok:false}; }
    catch (_) { return {ok:false}; }
  }

  function pictureData(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Could not read picture'));
      reader.readAsDataURL(blob);
    });
  }

  // Only escaped shopper-facing text, not the hidden order record, enters this offline file.
  function cartInfoHTML(cart, pictures, totals) {
    const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]));
    const rows = entries => entries.map(([key, value]) => `<div><dt>${escape(key)}</dt><dd>${escape(value)}</dd></div>`).join('');
    const articles = cart.items.map(item => {
      const id = item.properties?._configuration_id;
      const picture = lineRole(item) === 'shade' ? pictures.get(id) : null;
      const title = [prop(item.properties, 'Room'), prop(item.properties, 'Room / Window Label')].filter(Boolean).join(' — ');
      return `<article><h2>${escape(title || item.product_title || 'Item')}</h2><p>${escape(item.product_title)}</p>`
        + (picture && /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/=]+$/.test(picture)
          ? `<img src="${picture}" alt="${escape(`Window preview: ${title || 'Window'}`)}">`
          : lineRole(item) === 'shade' ? '<p>No saved picture for this shade in this browser.</p>' : '')
        + `<dl>${rows(publicProperties(item.properties))}${rows([['Quantity', item.quantity], ['Line total', formatMoney(item.final_line_price, cart.currency)]])}</dl></article>`;
    }).join('');
    return '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">'
      + '<meta http-equiv="Content-Security-Policy" content="default-src \'none\'; img-src data:; style-src \'unsafe-inline\'; base-uri \'none\'; form-action \'none\'">'
      + '<title>No Drill — Cart info</title><style>body{font:16px/1.5 system-ui,sans-serif;color:#222;margin:2rem auto;padding:0 1rem;max-width:70rem;overflow-wrap:anywhere}article{border-top:1px solid #bbb;padding:1rem 0;break-inside:avoid}img{display:block;max-width:100%;max-height:28rem;object-fit:contain;margin:1rem 0}dl>div{display:flex;gap:1rem;margin:.3rem 0;flex-wrap:wrap}dt{font-weight:bold}dd{margin:0}h1,h2{line-height:1.2}@media print{body{font-size:11pt;margin:0;max-width:none}img{max-height:14rem;max-width:100%}h2{break-after:avoid}article{break-inside:avoid}}</style></head><body>'
      + `<h1>No Drill — Cart info</h1><p>Saved ${escape(new Date().toLocaleString())}</p>`
      + '<p>This is a copy of your cart, not an order receipt. Prices may change. Check the final price and tax at checkout.</p>'
      + '<p>This file has a copy of each saved picture. The pictures are not on our servers. They will not be in your order email. Use your browser’s Print menu to print or save a PDF.</p>'
      + articles + `<section><h2>Cart summary</h2><dl>${rows(totals)}</dl></section></body></html>`;
  }

  async function setupShopifyCart(section) {
    const roomsNode = section.querySelector('[data-cart-rooms]');
    const emptyNode = section.querySelector('[data-cart-empty]');
    const statusNode = section.querySelector('[data-cart-status]');
    if (!roomsNode || !emptyNode || !statusNode || section.dataset.cartMode === 'shopify') return;
    section.dataset.cartMode = 'shopify';
    const client = globalThis.NoDrillCartClient;
    const cartClient = client?.create?.({ fetch: globalThis.fetch.bind(globalThis), root: cartRoot() });
    const getCart = () => cartClient?.get ? cartClient.get() : cartRequest('cart.js');
    const remoteForm = section.querySelector('[data-cart-remote-form]');
    const remoteType = section.querySelector('[data-cart-remote-type]');
    const remoteQuantity = section.querySelector('[data-cart-remote-quantity]');
    const remoteButton = section.querySelector('[data-cart-add-remote]');
    const remoteStatus = section.querySelector('[data-cart-remote-status]');
    const checkout = section.querySelector('[data-checkout-gate]');
    const checkoutEnabled = section.dataset.checkoutEnabled === 'true';
    let checkoutHasItems = false;
    let busy = true;
    let pendingRemote = null;
    let remoteOffered = false; // Unknown until the cart loads, so the form starts hidden.
    let closeOpenConfirm = null; // Only one "are you sure" question is open at a time.
    const download = section.querySelector('[data-cart-download]');
    const photoStatus = section.querySelector('[data-cart-photo-status]');
    let currentCart = null;
    let downloading = false;
    let photoRender = 0;
    const photoURLs = new Set();
    const fileURLs = new Set();
    const showPhotoStatus = text => { if (photoStatus) { photoStatus.textContent = text; photoStatus.hidden = !text; } };
    const clearPhotoURLs = () => {
      photoRender++;
      photoURLs.forEach(url => URL.revokeObjectURL(url));
      photoURLs.clear();
    };
    globalThis.addEventListener('pagehide', () => {
      clearPhotoURLs();
      fileURLs.forEach(url => URL.revokeObjectURL(url));
      fileURLs.clear();
    });
    globalThis.addEventListener('pageshow', event => { if (event.persisted && currentCart) { render(currentCart); refreshControls(); } });
    // Black Friday (NDR-D-145, Albert Nov 3): while the sale runs, add code BF51 to any cart with a shade, so nobody
    // pays full price for missing the banner. At most one POST per page load, never retried. Codes already in the
    // cart stay. Totals are read fresh afterwards, because Shopify's update reply does not carry final totals.
    let saleCodeTried = false;
    async function withSaleCode(cart) {
      if (saleCodeTried || Date.now() >= SALE_ENDS_AT || !cart.items.some((item) => lineRole(item) === 'shade')) return cart;
      const codes = (cart.discount_codes || []).map((entry) => String(entry?.code || '')).filter(Boolean);
      if (codes.some((code) => code.toUpperCase() === SALE_CODE)) return cart;
      saleCodeTried = true;
      try {
        await cartRequest('cart/update.js', { method: 'POST', body: JSON.stringify({ discount: [...codes, SALE_CODE].join(',') }) });
        return await getCart();
      } catch (_error) {
        return cart;
      }
    }
    async function showPicture(item, details, version) {
      if (lineRole(item) !== 'shade' || !item.properties?._configuration_id) return;
      const picture = await localPicture('load', item.properties._configuration_id);
      if (version !== photoRender || !details.isConnected) return;
      if (!picture.ok) { showPhotoStatus('We could not read saved pictures in this browser. You can still use your cart.'); return; }
      if (!picture.blob) return;
      const url = URL.createObjectURL(picture.blob);
      photoURLs.add(url);
      const figure = document.createElement('figure');
      figure.className = 'ndr-cart-item__photo';
      figure.dataset.cartPhoto = '';
      const image = document.createElement('img');
      const room = prop(item.properties, 'Room') || '';
      const windowLabel = prop(item.properties, 'Room / Window Label') || 'Window';
      image.alt = `Your window preview: ${room} — ${windowLabel}`;
      image.src = url;
      image.decoding = 'async';
      image.addEventListener('error', () => { figure.remove(); URL.revokeObjectURL(url); photoURLs.delete(url); showPhotoStatus('We could not open this saved picture.'); });
      const link = textElement('a', 'ndr-cart-item__picture-download', 'Download picture');
      link.href = url;
      // A fixed safe name plus the local ID avoids putting room names into filesystem paths.
      link.download = `no-drill-window-${String(item.properties._configuration_id).replace(/[^a-zA-Z0-9-]/g, '').slice(0,80)}.${picture.blob.type === 'image/png' ? 'png' : 'jpg'}`;
      figure.append(image, link);
      details.append(figure);
    }
    download?.addEventListener('click', async () => {
      if (busy || downloading || !currentCart?.items.length) return;
      // Snapshot both lines and the rendered totals before asynchronous picture reads.
      const cart = currentCart;
      const totals = [...section.querySelectorAll('[data-cart-summary] > dl > div')]
        .filter(row => !row.hidden).map(row => [row.querySelector('dt')?.textContent, row.querySelector('dd')?.textContent]);
      downloading = true;
      refreshControls();
      showPhotoStatus('Getting your cart file ready…');
      try {
        const pictures = new Map();
        let unreadable = false;
        await Promise.all(cart.items.filter(item => lineRole(item) === 'shade').map(async item => {
          const id = item.properties?._configuration_id;
          if (!id) return;
          const record = await localPicture('load', id);
          if (!record.ok) unreadable = true;
          if (record.blob) {
            try { pictures.set(id, await pictureData(record.blob)); } catch (_) { unreadable = true; }
          }
        }));
        const file = new Blob([cartInfoHTML(cart, pictures, totals)], {type:'text/html;charset=utf-8'});
        const url = URL.createObjectURL(file);
        fileURLs.add(url);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'no-drill-cart-info.html';
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => { URL.revokeObjectURL(url); fileURLs.delete(url); }, 60000);
        showPhotoStatus(unreadable ? 'Cart info is ready. Some pictures could not be read, so the file may not have them.'
          : 'Cart info is ready. Check your downloads for the file.');
      } catch (_) { showPhotoStatus('We could not make the cart file. Please try again.'); }
      finally { downloading = false; refreshControls(); }
    });
    const setText = (selector, text) => {
      const node = section.querySelector(selector);
      if (node) node.textContent = text;
    };
    const setTotal = (name, text) => setText(`[data-cart-total="${name}"]`, text);
    setText('[data-cart-kicker]', 'Your cart');
    setText('[data-cart-intro]', 'Shades are grouped by room. Each has its own line. The price is for the size and choices you made.');
    setText('[data-cart-summary-kicker]', 'Order summary');
    setText('[data-cart-label="subtotal"]', 'Subtotal');
    setText('[data-cart-label="total"]', 'Total before tax');
    setText('[data-cart-label="discount"]', Date.now() < SALE_ENDS_AT ? `Black Friday code ${SALE_CODE}` : 'Discount');
    // NDR-D-139 (Albert, Oct 29): 1 shade pays $48 shipping; 2 or more shades ship free for the whole order. Remotes
    // and side channels do not count. Mirrors the Shopify weight rate (each shade 10 lb, add-ons 0 lb, free at 20 lb).
    setText('[data-cart-benefit]', '');
    setText('[data-cart-fineprint]', checkoutEnabled ? '' : 'Ordering is not available yet.');
    if (checkoutEnabled) {
      const fineprint = section.querySelector('[data-cart-fineprint]');
      if (fineprint) fineprint.hidden = true;
    }
    setText('[data-cart-empty] h2', 'Your cart is empty');
    setText('[data-cart-empty] p', 'Configure a shade, then choose “Add to cart”.');
    section.querySelectorAll('[data-cart-discount-row], [data-cart-remote-summary], [data-edit-configuration]').forEach((node) => {
      node.hidden = true;
    });

    function showStatus(text) {
      statusNode.textContent = text;
      statusNode.hidden = !text;
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('.ndr-chrome__cart').forEach((link) => {
        const number = link.querySelector('strong');
        if (number) {
          number.textContent = String(count);
          number.hidden = !count;
        }
        link.setAttribute('aria-label', `Cart with ${count} items`);
      });
    }

    // One POST through the same checked add path as the builder (variant and price must match), never retried.
    async function duplicateShade(item) {
      if (busy || !cartClient?.addItems) return;
      if (closeOpenConfirm) closeOpenConfirm(false);
      const oldId = item.properties?._configuration_id;
      busy = true;
      refreshControls();
      showStatus('Adding a copy…');
      let sent = false;
      try {
        const latest = await getCart();
        const request = duplicateRequest(oldId, latest.items, newCopyId());
        if (!request.ok) throw new Error(request.message);
        sent = true;
        await cartClient.addItems(request.items, request.expectedUnitCents);
        const newId = request.items[0].properties._configuration_id;
        const editable = copyEditRecord(oldId, newId, request.label);
        const picture = await localPicture('load', oldId);
        if (picture.ok && picture.blob) await localPicture('save', newId, picture.blob);
        render(await getCart());
        showStatus(`Copy added: ${request.name}.${editable ? ' Use Edit to change its name or size.' : ''}`);
      } catch (error) {
        try { render(await getCart()); } catch (_error) { /* Keep the message below. */ }
        showStatus(`${error.message || 'We could not copy that shade.'}${sent ? ' Check your cart before you try again.' : ''}`);
      } finally {
        busy = false;
        refreshControls();
      }
    }

    function render(cart) {
      currentCart = cart;
      clearPhotoURLs();
      closeOpenConfirm = null;
      checkoutHasItems = cart.items.length > 0;
      const currency = cart.currency || 'USD';
      roomsNode.replaceChildren();
      emptyNode.hidden = cart.items.length > 0;
      groupCartItems(cart.items).forEach((items, room) => {
        const group = document.createElement('section');
        group.className = 'ndr-cart-room';
        group.append(textElement('h2', 'ndr-cart-room__title', room));
        placeCopies(items).forEach((item) => {
          const article = document.createElement('article');
          article.className = 'ndr-cart-item';
          const details = document.createElement('div');
          details.append(
            textElement('p', 'ndr-cart-item__category', item.product_title || 'Custom roller shade'),
            textElement('h3', '', lineRole(item) === 'remote' ? remoteTitle(item)
              : lineRole(item) === 'side_channel' ? 'Side channels' : (prop(item.properties, 'Room / Window Label') || 'Window')),
          );
          const list = document.createElement('dl');
          list.className = 'ndr-cart-item__details';
          displayRows(item)
            .forEach(([key, value]) => {
              const row = document.createElement('div');
              row.append(textElement('dt', '', key), textElement('dd', '', String(value)));
              list.append(row);
            });
          if (lineRole(item) === 'shade') {
            // Short summary first; the full setup folds away so a multi-shade cart stays scannable.
            const summaryText = shadeSummary(item.properties);
            if (summaryText) details.append(textElement('p', 'ndr-cart-item__summary', summaryText));
            const more = document.createElement('details');
            more.className = 'ndr-cart-item__more';
            const label = textElement('summary', '', 'Show all details');
            more.append(label, list);
            more.addEventListener('toggle', () => { label.textContent = more.open ? 'Hide details' : 'Show all details'; });
            details.append(more);
          } else {
            details.append(list);
          }
          if (item.sideChannels?.length) {
            const addons = document.createElement('ul');
            addons.className = 'ndr-cart-item__addons';
            item.sideChannels.forEach((channel) => {
              const row = document.createElement('li');
              row.append(textElement('span', '', 'Side channels'), textElement('strong', '', formatMoney(channel.final_line_price, currency)));
              addons.append(row);
            });
            details.append(addons);
          }
          const remove = textElement('button', 'ndr-cart-item__remove', 'Remove');
          remove.type = 'button';
          remove.disabled = busy;
          let actions = null;
          // Owner request (Oct 8): ask before a line leaves the cart, so one stray tap loses nothing.
          const question = lineRole(item) === 'remote' ? 'Remove this remote?' : 'Remove this shade? You would have to set it up again.';
          remove.addEventListener('click', () => {
            if (busy) return;
            if (closeOpenConfirm) closeOpenConfirm(false);
            const hideTarget = actions || remove;
            const confirm = document.createElement('div');
            confirm.className = 'ndr-cart-item__confirm';
            confirm.setAttribute('role', 'group');
            confirm.setAttribute('aria-label', question);
            const yes = textElement('button', 'ndr-cart-item__confirm-yes', 'Yes, remove');
            yes.type = 'button';
            const keep = textElement('button', 'ndr-cart-item__confirm-keep', 'Keep it');
            keep.type = 'button';
            const buttons = document.createElement('div');
            buttons.className = 'ndr-cart-item__confirm-actions';
            buttons.append(yes, keep);
            // The question sits where Remove was; a quick second tap lands on text, not on Yes.
            confirm.append(textElement('p', 'ndr-cart-item__confirm-text', question), buttons);
            const close = (restoreFocus) => {
              if (closeOpenConfirm === close) closeOpenConfirm = null;
              confirm.remove();
              hideTarget.hidden = false;
              if (restoreFocus) remove.focus();
            };
            keep.addEventListener('click', () => close(true));
            confirm.addEventListener('keydown', (event) => {
              if (event.key !== 'Escape') return;
              event.preventDefault();
              close(true);
            });
            yes.addEventListener('click', async () => {
              if (busy) return;
              busy = true;
              refreshControls();
              showStatus('Removing…');
              try {
                const updated = await removeLine(item.key, cart.items);
                const id = item.properties?._configuration_id;
                let cleanupFailed = false;
                if (lineRole(item) === 'shade' && id
                  && !updated.items.some(line => lineRole(line) === 'shade' && line.properties?._configuration_id === id)) {
                  cleanupFailed = !(await localPicture('remove', id)).ok;
                }
                showStatus((lineRole(item) === 'remote' ? 'Remote removed.' : 'Window removed.')
                  + (cleanupFailed ? ' We could not clear its picture from this browser.' : ''));
                render(updated);
              } catch (error) {
                close(true);
                showStatus(`${error.message || 'Could not remove that item.'} Refresh the page to see the current cart.`);
              } finally {
                busy = false;
                refreshControls();
              }
            });
            hideTarget.hidden = true;
            controls.append(confirm);
            closeOpenConfirm = close;
            keep.focus();
          });
          const controls = document.createElement('div');
          controls.className = 'ndr-cart-item__controls';
          // The big number is always the line total; a small line under it says what one costs and how many.
          const count = Number(item.quantity) || 0;
          controls.append(textElement('strong', 'ndr-cart-item__price', formatMoney(item.final_line_price, currency)));
          const fullLine = Number(item.original_line_price || 0);
          const paidLine = Number(item.final_line_price || 0);
          if (lineRole(item) === 'shade' && paidLine < fullLine) {
            // Black Friday (NDR-D-145): the saving, then the regular price crossed out. "Regular price", never "Was".
            controls.append(textElement('p', 'ndr-cart-item__deal',
              `${Date.now() < SALE_ENDS_AT ? 'Black Friday: ' : ''}${formatMoney(fullLine - paidLine, currency)} off`));
            const regular = textElement('p', 'ndr-cart-item__unit', '');
            regular.append(textElement('s', '', `Regular price ${formatMoney(fullLine, currency)}`));
            controls.append(regular);
          }
          if (lineRole(item) === 'remote' || count > 1) {
            const each = typeof item.final_price === 'number'
              ? item.final_price : Math.round(Number(item.final_line_price || 0) / Math.max(1, count));
            controls.append(textElement('p', 'ndr-cart-item__unit',
              count > 1 ? `${formatMoney(each, currency)} each · Qty ${count}` : `Qty ${count}`));
          }
          controls.append(remove);
          const extras = [];
          const editUrl = cartEditUrl(item);
          if (editUrl) {
            const edit = textElement('button', 'ndr-cart-item__remove', 'Edit');
            edit.type = 'button';
            edit.disabled = busy;
            edit.setAttribute('aria-label', `Edit ${room} - ${prop(item.properties, 'Room / Window Label') || 'Window'}`);
            edit.addEventListener('click', () => { if (!busy) globalThis.location.href = editUrl; });
            extras.push(edit);
          }
          if (cartClient?.addItems && canDuplicate(item, cart.items)) {
            const copy = textElement('button', 'ndr-cart-item__remove ndr-cart-item__duplicate', 'Duplicate');
            copy.type = 'button';
            copy.disabled = busy;
            copy.setAttribute('aria-label', `Duplicate ${room} - ${prop(item.properties, 'Room / Window Label') || 'Window'}`);
            copy.addEventListener('click', () => duplicateShade(item));
            extras.push(copy);
          }
          if (extras.length) {
            actions = document.createElement('div');
            actions.className = 'ndr-cart-item__actions';
            actions.append(remove, ...extras);
            controls.append(actions);
          }
          const swatch = lineRole(item) === 'shade' ? swatchUrl(item.properties) : '';
          if (swatch) {
            const image = document.createElement('img');
            image.className = 'ndr-cart-item__swatch';
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 160;
            image.height = 160;
            image.addEventListener('error', () => { image.remove(); article.className = 'ndr-cart-item'; });
            image.src = swatch;
            article.className = 'ndr-cart-item ndr-cart-item--with-swatch';
            article.append(image, details, controls);
          } else {
            article.append(details, controls);
          }
          group.append(article);
          showPicture(item, details, photoRender).catch(() => showPhotoStatus('We could not open a saved picture.'));
        });
        roomsNode.append(group);
      });
      remoteOffered = cart.items.some(isMotorizedShade);
      const alert = section.querySelector('[data-cart-remote-alert]');
      const warning = remoteWarning(cart.items) || remoteOrphanNote(cart.items) || remoteRoomNote(cart.items);
      if (alert) { alert.textContent = warning; alert.hidden = !warning; }
      const shadeLines = cart.items.filter((item) => lineRole(item) === 'shade');
      const shadeCount = shadeLines.reduce((sum, item) => sum + item.quantity, 0);
      // Same rule as the Shopify rate (NDR-D-139): 2 or more shade units ship free; add-ons do not count.
      const paidCents = Number(cart.total_price || 0);
      const hasItems = Number(cart.item_count || 0) > 0;
      const freeShipShades = 2;
      const shipCents = hasItems && shadeCount < freeShipShades ? 4800 : 0;
      const dealCents = Math.max(0, Number(cart.original_total_price || 0) - paidCents);
      setTotal('quantity', String(shadeCount));
      setTotal('subtotal', formatMoney(dealCents ? cart.original_total_price : cart.items_subtotal_price, currency));
      setTotal('discount', `−${formatMoney(dealCents, currency)}`);
      section.querySelector('[data-cart-discount-row]')?.toggleAttribute('hidden', !dealCents);
      setTotal('shipping', hasItems ? (shipCents ? formatMoney(shipCents, currency) : 'Free') : '-');
      section.querySelector('[data-cart-shipping-row]')?.toggleAttribute('hidden', !hasItems);
      setTotal('total', formatMoney(paidCents + shipCents, currency));
      // Black Friday (NDR-D-145): name the code under the total once Shopify has applied it.
      const saleCodeOn = (cart.discount_codes || []).some((entry) => entry?.applicable === true
        && String(entry.code || '').toUpperCase() === SALE_CODE);
      const saleLine = saleCodeOn && dealCents ? `Code ${SALE_CODE} added for you. You save ${formatMoney(dealCents, currency)}.` : '';
      const nudges = saleLine ? [saleLine] : [];
      if (hasItems) nudges.push(shipCents
        ? (shadeCount === 1 ? 'Add 1 more shade and shipping is free.' : 'Shipping is free on 2 or more shades.')
        : 'Free shipping on this order.');
      const benefitNode = section.querySelector('[data-cart-benefit]');
      if (benefitNode) { benefitNode.textContent = nudges.join(' '); benefitNode.hidden = !nudges.length; }
      updateHeaderCount(badgeCount(cart));
    }

    function showRemoteStatus(text) {
      if (remoteStatus) { remoteStatus.textContent = text; remoteStatus.hidden = !text; }
    }

    function refreshControls() {
      if (download) download.disabled = busy || downloading || !currentCart?.items.length;
      if (checkout) checkout.disabled = !checkoutEnabled || !checkoutHasItems || busy || !!pendingRemote;
      roomsNode.querySelectorAll('.ndr-cart-item__remove, .ndr-cart-item__confirm-yes, .ndr-cart-item__confirm-keep').forEach((button) => { button.disabled = busy; });
      if (!remoteForm || !remoteType || !remoteQuantity || !remoteButton) return;
      // Keep an unconfirmed add visible so its status message stays on screen.
      remoteForm.hidden = !(remoteOffered || pendingRemote);
      let available = true;
      try {
        if (!cartClient?.addItems) throw new Error(ADDONS_UNAVAILABLE);
        if (!pendingRemote) remoteRequest(client, remoteType.value, remoteQuantity.value);
      } catch (error) {
        available = false;
        showRemoteStatus(error.message);
      }
      remoteButton.disabled = busy || !available;
      remoteButton.textContent = busy ? 'Please wait…' : 'Add a remote';
      remoteType.disabled = busy || !!pendingRemote;
      remoteQuantity.disabled = busy || !!pendingRemote;
    }

    async function reconcile(request, current) {
      // Only this add's line counts; remotes added earlier are separate lines.
      const addId = request.items[0].properties._remote_add_id;
      const mine = Array.isArray(current?.items)
        ? { ...current, items: current.items.filter((item) => item.properties?._remote_add_id === addId) } : current;
      const result = cartClient?.reconcile
        ? await cartClient.reconcile(request.items, request.expectedUnitCents, mine)
        : reconcileRemote(request, mine);
      if (result !== true && result !== false) throw new Error('Could not confirm the remote. Check your cart before you try again.');
      return result;
    }

    remoteForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy) return;
      let request;
      try {
        if (!cartClient?.addItems) throw new Error(ADDONS_UNAVAILABLE);
        request = pendingRemote || remoteRequest(client, remoteType.value, remoteQuantity.value);
      } catch (error) { showRemoteStatus(error.message); return; }
      busy = true;
      refreshControls();
      showRemoteStatus('Checking your cart…');
      let sent = false;
      try {
        // Always read before posting, including after a lost response or repeated submit.
        const before = await getCart();
        render(before);
        if (await reconcile(request, before)) {
          pendingRemote = null;
          showRemoteStatus('Remote already added to your cart.');
          return;
        }
        pendingRemote = request;
        sent = true;
        await cartClient.addItems(request.items, request.expectedUnitCents);
        const after = await getCart();
        render(after);
        if (!await reconcile(request, after)) throw new Error('The cart did not confirm the remote.');
        pendingRemote = null;
        showRemoteStatus('Remote added to your cart.');
      } catch (error) {
        let message = error.message || 'Could not confirm the remote.';
        if (sent) {
          try {
            const current = await getCart();
            render(current);
            if (await reconcile(request, current)) {
              pendingRemote = null;
              showRemoteStatus('Remote added to your cart.');
              return;
            }
            pendingRemote = null; // Confirmed absent. A later user submit may retry; never auto-POST.
          } catch (failure) { message = failure.message || message; }
        }
        showRemoteStatus(`${message} Check your cart. Then try again or reload the page.`);
      } finally {
        busy = false;
        refreshControls();
      }
    });
    ['input', 'change'].forEach((name) => remoteForm?.addEventListener(name, () => {
      if (!pendingRemote && !busy) { showRemoteStatus(''); refreshControls(); }
    }));

    if (checkout) {
      checkout.disabled = true;
      checkout.textContent = checkoutEnabled ? 'Check out' : 'Cannot check out yet';
      checkout.addEventListener('click', () => {
        if (checkoutEnabled && checkoutHasItems && !busy && !pendingRemote) globalThis.location.href = `${cartRoot()}checkout`;
      });
    }
    emptyNode.hidden = true;
    ['quantity', 'subtotal', 'total'].forEach((name) => setTotal(name, '-'));
    refreshControls();
    showStatus('Loading your cart…');
    try {
      const cart = await withSaleCode(await getCart());
      showStatus('');
      render(cart);
    } catch (error) {
      showStatus(`We could not load your cart. Refresh the page to try again.`);
    } finally {
      busy = false;
      refreshControls();
    }
  }

  globalThis.NoDrillShopifyCartView = { badgeCount, canDuplicate, duplicateRequest, copyLabel, placeCopies, cartRequest, removeLine, publicProperties, shadeSummary, displayRows, remoteTitle, swatchUrl, groupCartItems, remoteWarning, remoteOrphanNote, remoteRoomNote, remoteRequest, reconcileRemote, setupShopifyCart };

  function initialize() {
    document.querySelectorAll('[data-no-drill-cart]').forEach(globalThis.location.pathname.endsWith('.html') ? setup : setupShopifyCart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
